// Search params do Relatório de Operadores (/reports/sellers): período, operador
// escolhido e ordenação da tabela ficam na URL — o link compartilhado abre no
// mesmo recorte e o F5 não perde o filtro. Defaults (todos os operadores,
// ordenação por volume decrescente) são omitidos para manter a URL curta.
import { validateDateRangeSearch } from "./lib/date-range-search";

export const SELLERS_SORT_KEYS = [
  "name",
  "status",
  "total",
  "completed",
  "rate",
  "conversions",
  "conversionRate",
  "totalDurationSec",
  "avgSec",
  "avgWaitSec",
  "availableSeconds",
  "occupancy",
  "lastActivityAt",
] as const;

export type SellersSortKey = (typeof SELLERS_SORT_KEYS)[number];
export type SellersSortDir = "asc" | "desc";

export const SELLERS_DEFAULT_SORT: { key: SellersSortKey; dir: SellersSortDir } = {
  key: "total",
  dir: "desc",
};

export interface SellersReportSearch {
  from?: string;
  to?: string;
  sellerId?: string;
  sortBy?: SellersSortKey;
  sortDir?: SellersSortDir;
}

export function validateSellersReportSearch(raw: Record<string, unknown>): SellersReportSearch {
  const sellerId =
    typeof raw.sellerId === "string" && raw.sellerId.trim() ? raw.sellerId : undefined;
  const sortBy = (SELLERS_SORT_KEYS as readonly unknown[]).includes(raw.sortBy)
    ? (raw.sortBy as SellersSortKey)
    : undefined;
  const sortDir = raw.sortDir === "asc" || raw.sortDir === "desc" ? raw.sortDir : undefined;
  return { ...validateDateRangeSearch(raw), sellerId, sortBy, sortDir };
}

// Ordenação efetiva: sem nada na URL vale o default; só a direção na URL usa a
// coluna padrão com a direção pedida.
export function sellersSortFromSearch(search: SellersReportSearch): {
  key: SellersSortKey;
  dir: SellersSortDir;
} {
  return {
    key: search.sortBy ?? SELLERS_DEFAULT_SORT.key,
    dir: search.sortDir ?? SELLERS_DEFAULT_SORT.dir,
  };
}

// Ordenação → search params, omitindo o que iguala o default.
export function serializeSellersSort(sort: { key: SellersSortKey; dir: SellersSortDir }): {
  sortBy: SellersSortKey | undefined;
  sortDir: SellersSortDir | undefined;
} {
  const isDefault = sort.key === SELLERS_DEFAULT_SORT.key && sort.dir === SELLERS_DEFAULT_SORT.dir;
  return {
    sortBy: isDefault ? undefined : sort.key,
    sortDir: isDefault ? undefined : sort.dir,
  };
}
